import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=28b46ec5&scoped=true&"
import script from "./ServicesSection.vue?vue&type=script&lang=js&"
export * from "./ServicesSection.vue?vue&type=script&lang=js&"
import style0 from "./ServicesSection.vue?vue&type=style&index=0&id=28b46ec5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b46ec5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardTitle,VIcon,VMain,VOverlay,VProgressCircular,VSpacer,VSwitch,VTooltip})
